<div
  [formGroup]="formGroup!"
  [class]="config?.cssClass ? 'mb-4 ' + config!.cssClass: 'form-group'"
>
  <div class="form-check">
    <input
      class="form-check-input me-2"
      type="checkbox"
      [formControlName]="config?.name ?? null"
      [id]="config?.name"
      [name]="config?.name"
      [class.is-invalid]="invalid"
      [attr.data-testid]="config?.name"
    />
    <label
      for="{{ config?.name }}"
      class="form-check-label"
    >
      {{ config?.label }}
    </label>
  </div>
</div>

<div
  libFormFieldError
  [fieldConfig]="config!"
  [formComponent]="fc"
></div>
